import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import useSurveys from '@helsenorge/framework-utils/additional-page-content/useSurveys';
import { getSurveysCookie } from '@helsenorge/framework-utils/additional-page-content/utils';
import { getPath } from '@helsenorge/framework-utils/hn-page';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import { HNeventSetNoMarginFooter } from '@helsenorge/framework-utils/web-component/events';
import Feedback from '..';
import useFeedbackResources from './useFeedbackResources';
import { useAppSelector } from '../../store/hooks';
const FeedbackContainer = ({ url, pageTitle, tjenesteNavn = getPath() }) => {
    const { feedback, isError, isLoading } = useFeedbackResources(tjenesteNavn);
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const { data: surveys, isLoading: isSurveysLoading } = useSurveys({ languageCode: language });
    const surveyCookie = getSurveysCookie();
    const unansweredSurveys = surveys?.filter(survey => !surveyCookie || !(survey.id in surveyCookie));
    const hasUnansweredSurveys = (unansweredSurveys?.length ?? 0) > 0;
    // FeedbackForm skal ikke vises dersom det er andre undersøkelser på siden
    const showFeedback = !isSurveysLoading && !hasUnansweredSurveys && feedback && !isError && !isLoading;
    useEffect(() => {
        if (showFeedback) {
            HNeventSetNoMarginFooter(true);
        }
        return () => {
            HNeventSetNoMarginFooter(false);
        };
    }, [showFeedback]);
    if (!showFeedback) {
        return null;
    }
    return _jsx(Feedback, { url: url, pageTitle: pageTitle, resources: feedback });
};
export default FeedbackContainer;
